import React from "react";
import TradePending from "../TradePending";
import DrawerWrapper from "src/components/MyGarage/DrawerWrapper/Blocks/DrawerWrapper";
import { useSelector } from "react-redux";
import { getYearMakeModelTrim } from "src/store/selectors/tradePending";

const TradePendingDrawer = () => {
    const yearMakeModelTrim = useSelector(getYearMakeModelTrim);

    return (
        <DrawerWrapper
            title={`${yearMakeModelTrim ? "TradePending.editTitle" : "TradePending.addTitle"}`}
            translateTitle={true}
        >
            <TradePending isDrawer />
        </DrawerWrapper>
    );
};

export default TradePendingDrawer;
